



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Module } from '@/interfaces/Module';

@Component({})
export default class MoveStepToOtherBlueprintDialog extends Vue {
  @Prop({ default: () => false })
  value!: boolean;

  @Prop({ default: () => 0 })
  cutoverplan_id!: number;

  selectedBlueprint?: number = -1;

  getModuleName(module: Module) {
    const preferredLanguage = module.moduleLanguages?.find(
      (language: any) => language.languageId === this.$store.state.user.languageId
    );
    return preferredLanguage?.name || module.moduleLanguages?.[0]?.name;
  }

  submit() {
    this.$emit('close', this.selectedBlueprint);
    this.selectedBlueprint = undefined;
  }
}
